/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Page_TitleInputs */

const en_orders_page_title = /** @type {(inputs: Orders_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logistics Orders`)
};

const es_orders_page_title = /** @type {(inputs: Orders_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos de logistica`)
};

/**
* | output |
* | --- |
* | "Logistics Orders" |
*
* @param {Orders_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_page_title = /** @type {((inputs?: Orders_Page_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Page_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_page_title(inputs)
	return es_orders_page_title(inputs)
});